import React, { useState, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import { useTranslation } from "react-i18next";
import useDetectClickOutside from "../../../../../hooks/useDetectClickOutside";

const CalendarComponent = ({ versionDate, setVersionDate, className }) => {
  const [showCalendar, setShowCalendar] = useState(false);

  const { t } = useTranslation();
  let calenderRef = useRef();

  useDetectClickOutside(calenderRef, () => {
    setShowCalendar(false);
  });

  const setVersionDateHandler = (event, from) => {
    switch (from) {
      case "Today":
        setVersionDate(UtilsHelper.getDateCoverted(new Date()));
        break;

      case "FutureDate":
        setVersionDate(UtilsHelper.getDateCoverted(event));
        setShowCalendar(false);
        break;
      default:
        break;
    }
  };

  return (
    <div
      className={
        className
          ? `calendar-container pos-relative ${className}`
          : "calendar-container pos-relative"
      }
    >
      <div className="d-flex jc-center align-center">
        <div
          className="calendar-today"
          onClick={(e) => setVersionDateHandler(e, "Today")}
          title={t("TMF.TEXT_TODAYLBL")}
        >
          <viedoc-icon name="arrow"></viedoc-icon>
        </div>
        <input
          size="4"
          value={versionDate ? UtilsHelper.getFormattedDate(versionDate) : ""}
          className="no-outline"
        />
        <div
          className="calendar jc-center align-center cursor-pointer"
          onClick={() => setShowCalendar((prevState) => !prevState)}
        >
          <viedoc-icon name="calender_today"></viedoc-icon>
        </div>
      </div>
      {showCalendar && (
        <div className="main-calendar" ref={calenderRef}>
          <Calendar
            onChange={(e) => setVersionDateHandler(e, "FutureDate")}
            value={versionDate}
          />
        </div>
      )}
    </div>
  );
};

export default CalendarComponent;
